import { getToken, deleteToken } from 'firebase/messaging';
import { getMessagingServizio } from './initFirebase';
import helpers from '../_helpers/helpersFunction';

// Chiede il permesso, ottiene il token FCM e lo salva sull'utente.
// Va chiamata da un gesto dell'utente (click). Esiti: 'ok' | 'non_supportato' | 'negato' | 'errore'
export async function attivaPush() {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return 'non_supportato';

    // il permesso va chiesto come PRIMA cosa asincrona: Safari lo ignora se il gesto dell'utente e' "scaduto"
    const permesso = await Notification.requestPermission();
    if (permesso !== 'granted') return 'negato';

    try {
        const push = await getMessagingServizio();
        if (!push) return 'non_supportato';

        if (!push.vapidKey) {
            console.error('[push] VAPID key mancante');
            return 'errore';
        }

        await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const serviceWorkerRegistration = await navigator.serviceWorker.ready;

        const token = await getToken(push.messaging, { vapidKey: push.vapidKey, serviceWorkerRegistration });
        if (!token) return 'errore';

        helpers.updatePushToken(token);
        return 'ok';
    } catch (err) {
        console.error('[push] errore nel recupero del token', err);
        return 'errore';
    }
}

// true se questo browser ha il permesso e una subscription push attiva (stato reale dello switch nel profilo)
export async function pushAttivo() {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return false;
    if (Notification.permission !== 'granted') return false;

    const registration = await navigator.serviceWorker.getRegistration('/');
    if (!registration) return false;

    return !!(await registration.pushManager.getSubscription());
}

// Toglie dall'utente il token di QUESTO browser (gli altri dispositivi restano) e annulla la subscription FCM.
// Esiti: 'ok' | 'errore'. Se il backend non conferma non si annulla nulla, cosi' restano coerenti.
export async function disattivaPush() {
    try {
        if (!(await pushAttivo())) return 'ok';

        const push = await getMessagingServizio();
        if (!push) return 'ok';

        const serviceWorkerRegistration = await navigator.serviceWorker.getRegistration('/');
        const token = await getToken(push.messaging, { vapidKey: push.vapidKey, serviceWorkerRegistration });

        if (token) await helpers.removePushToken(token);
        await deleteToken(push.messaging);
        return 'ok';
    } catch (err) {
        console.error('[push] errore nella disattivazione', err);
        return 'errore';
    }
}
